import React from "react";

type Status = "alert" | "success" | "error" | "warning";

export type Options = {
  message: string;
  status?: Status;
  duration?: number;
};

type State = {
  message: string;
  isOpen: boolean;
  duration: number;
  status: Status;
};
export type OpenSnackbarType = (options: Options) => void;

export type Context = {
  openSnackbar: OpenSnackbarType;
  state: State;
  setState: React.Dispatch<React.SetStateAction<State>>;
};

const defaults : State = {
  message: "success",
  isOpen: false,
  duration: 2000,
  status: "alert",
};

export default () : Context => {
  const [state, setState] = React.useState<State>(defaults);

  const openSnackbar = (opts: Options) => {
    if (!state.isOpen) {
      setState({
        ...defaults,
        ...opts,
        isOpen: true,
      });
    }
  };

  return { openSnackbar, state, setState };
};
